import { render } from "./base-form-shop.vue?vue&type=template&id=0c944d10&scoped=true"
import script from "./base-form-shop.vue?vue&type=script&lang=js"
export * from "./base-form-shop.vue?vue&type=script&lang=js"

import "./base-form-shop.vue?vue&type=style&index=0&id=0c944d10&scoped=true&lang=less"

import exportComponent from "/home/www/jenkins/jenkins_home/workspace/yizhige_production/yizhige_admin_pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c944d10"]])

export default __exports__